import { Flex, SkeletonCircle, SkeletonText } from '@billy/design-system'
import { ReactElement } from 'react'

import * as Styled from '../../styles'

const SKELETON_ROW_COUNT = 5

const NAME_WIDTHS = [220, 180, 260, 200, 240]
const DATE_WIDTHS = [80, 90, 75, 85, 80]
const AVATAR_WIDTHS = [100, 120, 90, 110, 130]

export const FileListSkeleton = (): ReactElement => (
  <Flex flexDirection="column">
    {Array.from({ length: SKELETON_ROW_COUNT }, (_, i) => (
      <Styled.SkeletonRow key={i}>
        <Styled.SkeletonCell flex={3}>
          <SkeletonCircle size={24} />
          <SkeletonText width={NAME_WIDTHS[i]} />
        </Styled.SkeletonCell>
        <Styled.SkeletonCell flex={1}>
          <SkeletonText width={DATE_WIDTHS[i]} />
        </Styled.SkeletonCell>
        <Styled.SkeletonCell flex={2}>
          <SkeletonCircle size={24} />
          <SkeletonText width={AVATAR_WIDTHS[i]} />
        </Styled.SkeletonCell>
      </Styled.SkeletonRow>
    ))}
  </Flex>
)
